import "./RetreatsPrograms.module.css";
import Header from "@/reusable_sections/Header";
import FindYourPathToInnerPeace from "./sections/FindYourPathToInnerPeace";
import UpcomingRetreatsPrograms from "./sections/UpcomingRetreatsPrograms";
import Footer from "@/reusable_sections/Footer";
export default function RetreatsProgramsPage() {
  return <div>
      <Header />
      <FindYourPathToInnerPeace />
      <UpcomingRetreatsPrograms />
      <Footer />
    </div>;
}